// i18n area 'apps' — locale fr-FR (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.fr-FR.meta.json.
import type { enUS } from './apps'

export const frFR: typeof enUS = {
  apps: {
    title: 'Apps',
    create: 'Créer une app',
    createTitle: 'Créer une app',
    editTitle: "Modifier l'app",
    name: 'Nom',
    nameHint: 'DNS-1123, unique dans le scope — immuable après la création.',
    node: 'Nœud',
    nodeHint: 'Le nœud membre qui la sert — placement explicite (le scheduler viendra plus tard).',
    image: 'Image',
    editImageHint: 'Une nouvelle référence se re-résout via le référentiel — le geste de pin/rollback.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Le digest ne bouge que sur commande.',
    policyTrackingHint: 'Rolling automatique quand un refresh déplace la branch.',
    archMovePolicy: 'Déplacement cross-arch',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: "Ce qui se passe si l'app est déplacée sur un nœud d'une autre architecture : refuse refuse le déplacement, reresolve re-résout le lockfile depuis la branch sur la nouvelle arch — le contenu change, et la réponse nomme le changement de digest.",
    network: 'Réseau',
    networkHint: 'Attachement L3 untagged : un réseau logique de fabric (recommandé — gateway/DNS depuis sa source unique), un overlay, ou un bridge host nu (déconseillé).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'bridge host:',
    ipAssignment: 'Attribution IP',
    ipStatic: 'Statique',
    ipAuto: 'Automatique (IPAM)',
    ipAssignmentHint_static: "C'est vous qui donnez l'adresse, maintenant.",
    ipAssignmentHint_auto: "L'IPAM choisit une adresse libre dans les plages réservées à TVirt du réseau.",
    bridgeDiscouraged: 'Bridge host nu — DÉCONSEILLÉ : TVirt ne sait rien de son adressage, gateway et DNS doivent donc être donnés à la main. La voie recommandée est un réseau logique de fabric.',
    ip: 'IP',
    ipHint: "IPv4 statique dans le subnet de l'attachement.",
    ipCidrHint: "En forme CIDR sur un bridge nu (ex. 192.168.1.10/24) — il n'y a pas de quoi dériver le préfixe.",
    gateway: 'Gateway',
    gatewayManualHint: 'Manuel — un bridge nu ne dérive rien.',
    dnsServers: 'Serveurs DNS',
    dnsManualHint: 'Manuels, séparés par des virgules — au moins un.',
    rootKind: 'Root',
    rootEphemeral: 'éphémère',
    rootPersistent: 'persistante',
    rootEphemeralHint: "Recréée depuis l'image à chaque recréation ; vit sur le storage éphémère de cluster.",
    rootEphemeralHintNamed: "Recréée depuis l'image à chaque recréation ; vit sur le storage éphémère de cluster ({name}).",
    rootPersistentHint: 'Survit aux redémarrages ; vit sur le storage que vous choisissez.',
    rootStorage: 'Storage root',
    editRootStorageHint: 'La root est re-rendue sur le nouveau pool — les données existantes ne se déplacent PAS toutes seules.',
    volumes: 'Volumes',
    volumeAdd: 'Ajouter un volume',
    volumeName: 'Nom',
    volumeMountPath: 'Chemin de mount',
    volumeKind: 'Type',
    volumeStorage: 'Storage',
    devices: 'Périphériques',
    deviceClassHint: "On demande une CLASSE (une étiquette gpu-device ou usb-device), jamais un périphérique précis : le nœud déclaré doit en posséder un marqué pour les Apps. Plusieurs Apps peuvent utiliser le même périphérique — un conteneur le partage, il ne le retire pas à l'hôte.",
    deviceSlot: 'Slot',
    deviceTag: 'Étiquette',
    deviceValue: 'Classe',
    deviceUnresolved: "rien ne se résout pour l'instant",
    noDeviceTags: 'Aucune étiquette de type gpu-device ou usb-device : créez-en une et affectez-la aux périphériques marqués pour les Apps.',
    env: 'Environnement',
    envHint: 'Une CLÉ=valeur par ligne.',
    secretEnvTitle: 'Variables secrètes',
    secretEnvNotice: "Une valeur secrète ne revient jamais de l'API : personne ne la relit, pas même celui qui l'a écrite. Dans le checkpoint elle voyage scellée avec la masterpass, donc une restauration sans la masterpass demandera de la réécrire.",
    secretEnvPromote: 'Rendez secrète une des variables écrites ci-dessus :',
    secretEnvAdd: 'Ajouter une variable secrète',
    secretEnvName: 'Nom',
    secretEnvValue: 'Valeur',
    secretEnvKept: 'conservée — laissez vide pour ne pas la changer',
    secretEnvWithdrawWarning: "Pour cesser de traiter comme secrète une variable qui l'est déjà, écrivez-lui une nouvelle valeur : retirer la marque à elle seule serait un moyen de LIRE ce qui ne sort pas du store. La supprimer, en revanche, l'efface.",
    secretEnvChip: 'secret',
    startNow: "Démarrer immédiatement (sinon l'app naît arrêtée)",
    deletePersistentIntro: 'Cette app a des données persistantes — choisissez quoi en faire :',
    deleteKeepData: 'Garder les données (les répertoires restent sur leurs storages, orphelins)',
    deletePurgeData: 'Supprimer aussi les données',
    phase: 'Phase',
    phase_running: 'En exécution',
    phase_stopped: 'Arrêtée',
    phase_error: 'Erreur',
    phase_unknown: 'Inconnue',
    desiredState: 'Voulu',
    wantedRunning: 'en exécution',
    wantedStopped: 'arrêtée',
    start: 'Démarrer',
    stop: 'Arrêter',
    restart: 'Redémarrer',
    refreshImage: "Rafraîchir l'image (adopter le nouveau @current)",
    logs: 'Logs',
    logsTitle: 'Logs',
    logsEmpty: 'Aucune sortie capturée.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: "L'App n'est pas en cours d'exécution — un shell a besoin d'un conteneur vivant. Ses logs se lisent dans n'importe quel état.",
    shellConnect: 'Connecter',
    shellDisconnect: 'Déconnecter',
    shellExited: "La session s'est terminée avec le code de sortie {code}.",
    shellEndedWithoutStatus: "La session s'est terminée sans état de sortie : {reason}",
    shellRevoked: "Le ticket de la session n'est plus valide — il a expiré, ou la connexion qui l'avait ouvert a été révoquée.",
    shellHint: 'Cliquez sur le cadre noir et tapez : les touches arrivent au conteneur. Ctrl+C et les flèches fonctionnent ; exit ferme le shell.',
    shellStatus: {
      connecting: 'Connexion…',
      connected: 'Connectée',
      ended: 'Terminée'
    },
    deleteRunningError: "{name} est voulue en exécution — arrêtez-la d'abord.",
    tabs: {
      general: 'Général',
      image: 'Image',
      network: 'Réseau',
      storage: 'Storage',
      devices: 'Périphériques',
      observed: 'Observé'
    },
    attachment: 'Attachement',
    runningDigest: 'Digest en exécution',
    lastError: 'Dernière erreur',
    reportObservedAt: 'Dernier report du worker',
    desiredStateLock: 'Gouverné par les actions Démarrer/Arrêter — jamais une modification directe.',
    ipEditDisabledHint: 'Modifiable seulement avec une attribution statique.',
    derivedFromNetworkHint: 'Dérivé de la source unique du réseau — manuel seulement sur un bridge nu avec IP statique.',
    ephemeralUnset: 'non configuré',
    ephemeralMissing: "Le storage éphémère des Apps n'est pas configuré — créer une app avec des morceaux éphémères (root ou volumes) est refusé tant qu'il n'est pas défini.",
    ephemeralCurrent: 'Storage éphémère des Apps : {name}',
    ephemeralMissingCreate: "Cette app a des morceaux éphémères mais le storage éphémère des Apps n'est pas défini — la création sera refusée. Définissez-le d'abord depuis le banner de la page Apps.",
    setEphemeral: 'Définir le storage éphémère',
    changeEphemeral: 'Changer le storage éphémère',
    setEphemeralTitle: 'Définir le storage éphémère des Apps',
    changeEphemeralTitle: 'Changer le storage éphémère des Apps',
    ephemeralStorageHint: "DEFAULT de cluster : le pool dir-like où vivent les roots et les volumes éphémères de chaque app, sauf override déclaré par l'app. Un changement n'est pas à chaud et ne redémarre rien : il vaut à partir du prochain start de chaque app — les données éphémères ne se déplacent pas.",
    ephemeralPool: 'Pool de storage',
    ephemeralOverride: 'Storage éphémère (override par app)',
    ephemeralOverrideInherit: 'Hériter du default de cluster',
    ephemeralOverrideInheritNamed: 'Hériter du default de cluster ({name})',
    ephemeralOverrideHint: "Pool par app pour la root et les volumes éphémères — laissez vide pour hériter du default de cluster. Le changer n'est pas à chaud et ne redémarre rien : il vaut à partir du prochain start (les données éphémères renaissent vides sur le nouveau pool) et requiert la permission app.ephemeralStorage.set.",
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Toutes les branches',
    imageBranchHint: 'Restreint les images à celles que cette branche nomme ; sans branche on voit toutes celles du repository.',
    imageDigestHint: 'Le contenu : il se choisit dans la table des digests, qui en porte la provenance et l’architecture. La même branche en offre un par architecture, et ils ne sont pas interchangeables.',
    imageLockfile: 'Référence résolue',
    imageNoImages: 'Aucune image en cache pour ce repository — téléchargez-en une depuis Images OCI.',
    imageHeadNotCached: 'pas en cache — récupéré au démarrage',
    imageNoRegistries: 'Aucun repository enregistré : enregistrez-en un pour pouvoir choisir une image.',
    imageChosenHint: 'L’image se choisit dans la cascade du dialogue de modification : la référence ne se tape jamais à la main.',
    registerRepositoryHint: 'Enregistrer ne télécharge rien : cela rend un repository observable, pour que l’image se choisisse sans quitter ce dialogue.',
    registerRepositoryBranchHint: 'Facultatif : la première branche à observer (p. ex. latest).',
    registerRepositoryElsewhere: 'Le repository cherché n’est pas enregistré : l’enregistrement se fait dans la section Images OCI, par qui en a la permission.'
  },
  cts: {
    createAction: 'Créer un CT',
    createTitle: 'Créer un container depuis un template',
    createError: "Le container n'a pas été créé",
    template: 'Template CT',
    noTemplates: 'Aucun template CT — importez-en un depuis Templates CT',
    resources: 'Ressources',
    node: 'Nœud',
    phase: {
      defined: 'Jamais allumé',
      materializing: 'En matérialisation',
      ready: 'Prêt',
      starting: 'En démarrage',
      running: 'En exécution',
      stopping: 'En arrêt',
      stopped: 'Arrêté',
      deleting: 'En suppression',
      error: 'En erreur'
    },
    actions: {
      start: 'Démarrer',
      stop: 'Arrêter',
      restart: 'Redémarrer',
      markTemplate: 'Promouvoir en template CT',
      error: "L'action a été refusée"
    },
    markTemplate: {
      confirmTitle: "Promouvoir '{name}' en template CT ?",
      confirmBody: 'Le container quitte cette liste et rejoint les Templates CT, aussitôt prêt à engendrer de nouveaux CT. Ses metadata restent modifiables, et vous pouvez le ramener en CT à tout moment.',
      confirm: 'Promouvoir',
      moved: "'{name}' est désormais un template CT — retrouvez-le dans Templates CT."
    },
    stopCause: {
      api: 'Arrêté via TVirt',
      'ct-exit': 'Le container est sorti tout seul',
      'host-reboot': 'Mort avec le redémarrage du nœud',
      'start-failed': "Le démarrage a échoué — l'erreur de la task dit ce qui manque et comment le corriger"
    },

    console: 'Console',
    consoleUnavailable: "Le container n'est pas en exécution — une console a besoin d'un container vivant. Ses logs, eux, se lisent dans n'importe quel état.",
    consoleNoTemplate: "Un template ne tourne jamais, il n'a donc pas de console : créez-en un CT et ouvrez la sienne.",
    consoleConnect: 'Connecter',
    consoleDisconnect: 'Déconnecter',
    consoleReconnect: 'Reconnecter',
    consoleTakenBy: 'Un autre opérateur a pris cette console ({user}). Une console par container : se reconnecter vous la reprend.',
    consoleHint: 'Cliquez sur le cadre noir et tapez : les touches arrivent au container. Ctrl+C et les flèches fonctionnent.',
    consoleEndpointDown: 'Le point d\'accès de la console ne s\'ouvre pas sur le nœud qui sert le container : {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Le container n\'est pas en cours d\'exécution — un shell a besoin d\'un container vivant. Ses logs se lisent dans n\'importe quel état.',
    shellNoTemplate: 'Un template ne tourne jamais, donc il n\'a pas de shell : créez un CT à partir de lui et ouvrez le sien.',
    shellConnect: 'Connecter',
    shellDisconnect: 'Déconnecter',
    shellExited: "La session s'est terminée avec le code de sortie {code}.",
    shellEndedWithoutStatus: "La session s'est terminée sans état de sortie : {reason}",
    shellRevoked: "Le ticket de la session n'est plus valide — il a expiré, ou la connexion qui l'avait ouvert a été révoquée.",
    shellHint: 'Cliquez sur le cadre noir et tapez : les touches arrivent au conteneur. Ctrl+C et les flèches fonctionnent ; exit ferme le shell.',
    shellStatus: {
      connecting: 'Connexion…',
      connected: 'Connectée',
      ended: 'Terminée'
    },
    rootPassword: 'Mot de passe root',
    rootPasswordHint: 'Écrit une seule fois dans le rootfs copié (sous forme de hash, jamais réaffiché). Les images des distributions n\'ont pas de mot de passe root : sans lui, le shell est la seule porte d\'entrée.',
    sshKeys: 'Clés SSH publiques de root',
    sshKeysHint: 'Une clé publique OpenSSH par ligne, dans root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Connexion…',
      connected: 'Connectée',
      reconnecting: 'Reconnexion…'
    },
    logs: 'Logs',
    logsTitle: 'Logs',
    logsEmpty: 'Aucune sortie capturée.',
    logsSource: 'Quel log',
    logsSourceConsole: "La console de l'init du container — pourquoi le service à l'intérieur n'a pas démarré",
    logsSourceSupervisor: "Le superviseur liblxc — pourquoi le container n'est jamais arrivé à démarrer",
    logsNeverStarted: "Il n'a jamais été démarré, il n'y a donc encore rien d'enregistré — démarrez-le, et les logs seront là même si le démarrage échoue.",
    logsNoTemplate: "Un template ne tourne jamais, il n'a donc jamais rien enregistré.",
    logsError: "Les logs n'ont pas été capturés",

    tabs: {
      general: 'Général',
      hardware: 'Hardware',
      network: 'Réseau',
      provenance: 'Provenance'
    },
    templateFlag: 'Template CT',
    templateLock: 'Ne change que par les actions Promouvoir / Ramener en CT — jamais une modification directe.',
    sourceLock: 'Provenance, enregistrée à la naissance — jamais réécrite ; une source morte laisse la référence nue.',
    storageLock: 'Fixé à la création — le déplacement du rootfs est un round futur.',
    startedAt: 'Démarré',
    lastStop: 'Dernier arrêt',
    editNicsTitle: 'Modifier les réseaux',
    nicDisconnected: 'déconnectée'
  },
  ctTemplates: {
    title: 'Templates CT',
    importAction: 'Importer depuis un catalogue',
    importTitle: 'Importer un template CT depuis le catalogue',
    importSubmit: 'Importer',
    importError: "L'import a été refusé",
    importHint: "Matérialiser copie le rootfs sur le storage choisi — le fichier de catalogue reste intact. Pour ajouter de nouveaux fichiers, chargez-les d'abord dans un catalogue.",
    sourceFile: 'Fichier template CT',
    sourceFileHint: 'Les fichiers ct-rootfs du catalogue choisi, seulement ceux qui sont prêts',
    noFiles: 'Aucun fichier ct-rootfs prêt dans ce catalogue — chargez-en un depuis la page du catalogue',
    source: "Fichier d'origine",
    rootfsStorage: 'Storage du rootfs',
    rootfsStorageHint: "Où vit l'arbre rootfs extrait — un storage avec filesystem et assez d'espace libre pour la taille extraite plus une marge d'environ 1 GiB (sinon l'import échoue).",
    resources: 'Ressources',
    cores: 'vCPU',
    memoryMiB: 'Mémoire (MiB)',
    cpuLimit: 'Limite CPU',
    cpuLimitHint: 'Équivalents de cores host (ex. 1.5) ; vide = sans plafond',
    cpuUncapped: 'sans plafond',
    cpuWeight: 'Poids CPU',
    hostname: 'Hostname',
    hostnameHint: 'Vide = le nom du CT',
    nameservers: 'Nameservers DNS',
    dnsHint: "Séparés par des virgules ; vide = hérite de ceux de l'host",
    searchDomains: 'Domaines de recherche DNS',
    dnsInherited: "Hérité de l'host",
    networks: 'Réseaux',
    nicSlot: 'Slot NIC',
    phase: {
      materializing: 'En matérialisation',
      ready: 'Prêt',
      deleting: 'En suppression',
      error: 'Erreur'
    },
    exportAction: 'Exporter vers le catalogue',
    exportTitle: 'Exporter vers le catalogue',
    exportSubmit: 'Exporter',
    exportError: "L'export a été refusé",
    exportHint: 'Empaquette le rootfs matérialisé dans un NOUVEAU fichier ct-rootfs dans le catalogue choisi — le template reste intact.',
    exportName: 'Nom du fichier',
    exportNameHint: 'Vide = <template>-export-<n>',
    markCt: {
      action: 'Ramener en CT',
      confirmTitle: "Ramener '{name}' en CT ?",
      confirmBody: 'Le template quitte cette liste et retourne dans la liste CT, de nouveau démarrable. Tant que vous ne le promouvez pas à nouveau, aucun CT ne peut être créé à partir de lui.',
      confirm: 'Ramener en CT',
      moved: "'{name}' est de nouveau un CT — retrouvez-le dans la liste CT."
    }
  },
  oci: {
    registriesTitle: 'Registries OCI',
    imagesTitle: 'Images OCI',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Générique',
    providerImmutableHint: 'Le provider est immuable après la création — un provider différent est un nouveau registry.',
    url: 'URL',
    urlHintPreset: 'Prérempli par le provider — remplacez seulement pour les mirrors.',
    urlHintRequired: "Obligatoire pour les registries génériques : l'URL de base https://.",
    urlHintEcr: "Obligatoire : les endpoints ECR sont par compte/par région — il n'existe pas de preset.",
    credential: 'Identifiant',
    credentialNone: 'Accès anonyme',
    credentialHint: "Une entrée keystore utilisateur-et-mot-de-passe ; les workers la résolvent au moment de l'usage — jamais d'auth files par nœud.",
    nameHint: 'Nom de type host (docker.io, registry.intra) ; unique par scope, immuable',
    addRegistry: 'Ajouter un registry',
    addRegistryTitle: 'Ajouter un registry OCI',
    verify: 'Vérifier',
    verifyState: 'Vérification',
    verified: 'Vérifié',
    verifyFailed: 'Échouée',
    neverVerified: 'Jamais vérifié',
    registryInUseError: "'{name}' a encore des repositories enregistrés — supprimez-les d'abord.",
    repositories: 'Repositories',
    repositoriesHint: "Enregistrer observe les branches (tags OCI) — rien n'est téléchargé. Le refresh résout chaque branch observée et conserve le reflog.",
    noRepositories: 'Aucun repository enregistré sur ce registry.',
    registerRepository: 'Enregistrer un repository',
    repoPath: 'Chemin',
    repoPathHint: "Chemin du repository sur le registry, ex. 'example' ou 'library/nginx'",
    branches: 'Branches',
    branchesHint: 'Branches observées (tags OCI), séparées par des virgules — ex. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: "Résolue MAINTENANT : le pull télécharge le digest vers lequel la branch pointe aujourd'hui.",
    refresh: 'Rafraîchir',
    deleteRepository: 'Supprimer le repository',
    reflogCount: '{n} précédents',
    noResolutions: 'Jamais rafraîchi — aucune résolution observée.',
    refreshFailed: 'Dernier rafraîchissement échoué ({when})',
    loadError: 'Impossible de charger les repositories.',
    reference: 'Référence',
    digest: 'Digest',
    digestHint: "sha256:… — l'image exacte, sans branch (detached)",
    size: 'Taille',
    nodes: 'Nœuds',
    detached: 'detached',
    detachedHint: "Téléchargée par digest, sans branch — le contrôle de drift ne s'applique pas.",
    pulledAt: 'Téléchargée',
    pull: 'Pull',
    pullTitle: "Pull d'image",
    pullHint: 'Pre-warming, jamais un prérequis : un pull par branch résout MAINTENANT et télécharge CE digest ; un pull par digest est detached.',
    pullError: 'Le pull a été refusé',
    pullMode: 'Pull par',
    pullModeBranch: 'Branch (résoudre maintenant)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Le default honnête : comme apt install, relancé plus tard il peut donner une image différente.',
    pullModeDigestHint: 'Digest exact — reproductibilité et rollback ; renonce au contrôle de drift.',
    importFromRegistry: 'Importer depuis un registry',
    importFromCatalog: 'Importer depuis un catalogue',
    importCatalogTitle: 'Importer une image OCI depuis un catalogue',
    importCatalogHint: "La voie air-gapped : une archive oci-image prête (tar/tar.gz — docker-archive ou oci-archive) est matérialisée dans le store d'images avec la référence catalog/<catalogue>/<file>@<digest> ; les apps la consomment comme n'importe quelle autre image. Les archives se chargent dans les catalogues — cette section ne fait qu'importer.",
    importCatalogFile: 'Archive',
    importCatalogFileHint: 'Les fichiers oci-image prêts du catalogue choisi.',
    importCatalogNoFiles: 'Aucune archive oci-image prête dans ce catalogue — chargez-en une depuis le détail du catalogue.',
    importCatalogError: "L'import a été refusé",
    registry: 'Registry',
    repository: 'Repository',
    cacheMissing: "Le cache OCI de cluster n'est pas configuré — les pulls sont refusés tant que vous ne définissez pas un pool de storage.",
    setCache: 'Définir le cache',
    setCacheTitle: 'Configurer le cache OCI',
    setCacheHint: "Le pool DEFAULT au niveau du cluster qui héberge les blobs des images téléchargées — un scope peut faire un override avec son propre pool (page Scopes). Le changer n'est pas à chaud et ne redémarre rien, et ne déplace pas les blobs : ils réapparaissent lazy au prochain start/usage.",
    cachePool: 'Pool de storage',
    changeCache: 'Changer le cache',
    changeCacheTitle: 'Changer le pool du cache OCI',
    cacheCurrent: 'Cache OCI du cluster (default) : {name}',
    sectionOverview: "Vue d'ensemble",
    sectionRepositories: 'Repositories',
    sectionExplore: 'Explorer',
    exploreHint: 'Recherche distante en direct sur le registry — Docker Hub complète (description, téléchargements, étoiles), autres providers best-effort. Sélectionnez un résultat pour lire sa description complète et parcourir ses tags distants ; depuis un tag vous pouvez ajouter la référence à un repository TVirt.',
    exploreSearch: 'Rechercher',
    exploreUnsupported: 'Ce provider ne supporte pas la recherche.',
    exploreNoResult: 'Aucun repository correspondant.',
    exploreNoTags: 'Aucun tag correspondant sur ce repository.',
    exploreOfficial: 'Officiel',
    explorePulls: 'Téléchargements',
    exploreStars: 'Étoiles',
    exploreUpdated: 'Mis à jour {when}',
    exploreLoadMore: 'Charger plus',
    exploreSelectHint: 'Sélectionnez un résultat : description complète et tags distants se chargent ici.',
    exploreNoDescription: 'Aucune description disponible depuis ce provider.',
    exploreTagsTitle: 'Tags distants',
    exploreTagFilter: 'Rechercher des tags',
    exploreAddToRepo: 'Ajouter à un repository',
    exploreAdded: '{path}:{tag} est désormais suivi — voir la section Repositories.',
    addBranch: 'Ajouter un branch',
    purgeRequiredTitle: "Supprimer '{name}' et ses images ?",
    purgeRequiredBody: 'Aucune app ne consomme ce repository, mais des images téléchargées existent encore : le supprimer retire aussi leurs enregistrements, et les blobs en cache passent au garbage collector.',
    purgeConfirm: 'Supprimer aussi les images',
    providerSelectHint: "Sélectionnez le type de registry : la carte raconte le preset et l'usage.",
    providerDesc: {
      dockerhub: 'Le registry public Docker : URL préremplie, recherche complète avec descriptions et compteurs.',
      ghcr: 'GitHub Container Registry : URL préremplie ; les comptes utilisent un personal access token.',
      ecr: "Amazon Elastic Container Registry : endpoints par compte/par région — l'URL doit être indiquée.",
      quay: 'Le registry Red Hat Quay : URL préremplie.',
      generic: "Registry self-hosted (Harbor, registry:2, …) : l'URL https:// est obligatoire."
    },
    layerCount: 'Layers',
    verifiedAt: 'Dernière vérification',
    verifyOk: 'Résultat',
    verifyMessage: 'Message de vérification',

    // Le modèle #348/R39 : l’image EST le digest — le contenu — et registry, repository et branch sont les NOMS qui l’atteignent.
    head: 'Head',
    heads: 'Têtes par architecture',
    listDigest: 'Digest de la liste',
    neverResolved: 'Jamais résolu',
    totalSize: 'Taille totale',
    reflogTitle: 'Historique des résolutions',
    usedBy: 'Utilisé par',
    usageLockfile: 'lockfile',
    usageRunning: 'en exécution',
    evictable: 'évinçable',
    evict: 'Évincer du cache',
    evictHeadTitle: 'Évincer {digest} ?',
    evictHeadBody: 'C’est la résolution actuelle d’au moins un collecteur : l’évincer est légitime — ce n’est que du cache, le branch distant le sert encore — mais cela ne doit jamais arriver par erreur. Le blob est UNIQUE : l’éviction vide tous les collecteurs qui le partagent.',
    evictConfirm: 'L’évincer quand même',

    arch: 'Architecture',
    names: 'Noms',
    noNames: 'aucun nom',
    views: 'Vues',
    lastView: 'dernière vue',
    evictLastViewTitle: 'Retirer la dernière référence à {digest} ?',
    evictLastViewBody: 'C’est la dernière vue sur ce contenu : en la retirant, l’image cesse d’exister sur TVirt et les octets ({size}) sont libérés. C’est le docker image rm du modèle — pas un effet de bord, l’opération elle-même.',
    branchesTabHint: 'Les branches observées de ce repository : pour chacune les têtes du jour — une par architecture — la chronologie des refresh et combien des images qu’elle a nommées sont en cache. Le refresh est le «git fetch» du repository : il résout toutes ses branches d’un coup.',
    noBranches: 'Aucune branche observée sur ce repository.',
    stopObserving: 'Cesser d’observer la branche',
    pullBranch: 'Récupérer en cache la tête du branch (le refresh résout, celui-ci télécharge)',
    pullDigest: 'Récupérer ce digest en cache',
    imageCount: 'Images',
    deleteBranchPurgeTitle: 'Laisser sans nom les images de {name} ?',
    deleteBranchPurgeBody: 'Aucune app ne nomme cette branche, mais certaines images ne sont atteintes que par elle : en la supprimant, elles restent en cache sans nom, listées parmi les images du repository et évinçables à la main.',
    deleteBranchPurgeConfirm: 'Supprimer et laisser les images sans nom',
    imagesTabHint: 'Les images de ce repository — les contenus, c’est-à-dire les digests — visibles même sans choisir de branche. Une image est unique par cluster : les noms qui l’atteignent peuvent être plusieurs.',
    noImages: 'Aucune image de ce repository n’est matérialisée en cache.',
    deleteRepositoryTitle: 'Supprimer {name} ?',
    deleteRepositoryBody: 'Le repository et ses branches disparaissent, avec leur chronologie. Les images restent en cache : elles perdent seulement ce nom. Un repository nommé par une app ne se supprime pas.',
    provenanceCatalog: 'catalogue',
    refreshedAt: 'Actualisé',
    neverRefreshed: 'Jamais actualisé',
    sectionBranches: 'Branches',
    sectionImages: 'Images',
    repositoriesGovernedElsewhere: 'Ici les repositories se consultent seulement : les enregistrer, les actualiser, observer leurs branches et évincer leurs images se fait dans la section Images OCI.',
    gotoImages: 'Aller aux images OCI'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pods',
    containers: 'Conteneurs',
    instances: 'Instances',
    instancesTooltip: '{running} en cours, {error} en erreur',
    placement: 'Placement',
    spread: 'répartition',
    ha: 'HA',
    templateRevision: 'révision',
    deleting: 'Suppression en cours',
    empty: 'Aucun pod — créez une app (un conteneur) ou un pod depuis la CLI (create-pod).',
    openInstances: 'Ouvrir les instances',
    rollingRestart: 'Redémarrage progressif',
    scale: 'Mettre à l’échelle',
    scaleTitle: 'Mettre à l’échelle {name}',
    scaleHint: 'Nombre d’instances (0–64) : vers le haut naît l’ordinal libre le plus bas, vers le bas le plus haut se retire et ses données persistantes restent.',
    scaleError: 'Échec de la mise à l’échelle',
    replicas: 'Réplicas',
    deleteRunningError: '{name} est en cours d’exécution — arrêtez-le d’abord.',
    deleteInstancesIntro: 'Les {count} instances seront supprimées.',
    stateRunning: 'En cours',
    stateStopped: 'Arrêté',
    editor: {
      createTitle: 'Créer un Pod',
      create: 'Créer un Pod',
      editTitle: 'Modifier le Pod',
      nameHint: 'DNS-1123, 58 caractères au plus — les instances s\'appellent <nom>-<index> ; immuable après la création.',
      restartPolicy: 'Politique de redémarrage',
      restartPolicyHint_always: 'Le nœud redémarre tout conteneur sorti, avec un backoff exponentiel (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Seul un conteneur sorti avec un code non nul est redémarré ; la sortie 0 reste au repos.',
      restartPolicyHint_never: 'Un conteneur sorti reste tel quel — l\'instance finit succeeded ou failed.',
      grace: 'Grâce (s)',
      graceHint: 'La borne SIGTERM → SIGKILL d\'un arrêt.',
      hostname: 'Nom d\'hôte',
      hostnameHint: 'Vide = le nom de l\'instance.',
      hostnameDefault: 'le nom de l\'instance',
      sharePid: 'Partager l\'espace de noms PID entre les conteneurs',
      containersIntro: 'Les conteneurs init s\'exécutent jusqu\'au bout, dans l\'ordre, avant le démarrage des conteneurs ; les conteneurs partagent le réseau de l\'instance (une IP, localhost entre eux).',
      initContainers: 'Conteneurs init',
      initAdd: 'Ajouter un conteneur init',
      initHint: 'Chacun doit sortir avec 0 ; un échec met l\'instance en erreur et le nœud le réessaie avec backoff.',
      containerAdd: 'Ajouter un conteneur',
      atLeastOne: 'Un Pod a besoin d\'au moins un conteneur.',
      duplicateNames: 'Les noms de conteneurs doivent être uniques dans le Pod (conteneurs init compris).',
      containerName: 'Nom du conteneur',
      containerInvalid: 'Ce conteneur est incomplet : nom (DNS-1123), image, montages sur des volumes déclarés, limites et sonde numériques.',
      command: 'Commande',
      commandHint: 'Remplace l\'entrypoint de l\'image — un argument par ligne, jamais une chaîne shell.',
      args: 'Arguments',
      argsHint: 'Un par ligne (le CMD de l\'image si vide).',
      mounts: 'Montages',
      mountAdd: 'Ajouter un montage',
      mountNoVolumes: 'Déclarez d\'abord un volume dans l\'onglet Stockage.',
      readOnly: 'lecture seule',
      resources: 'Limites',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (ex. 1.5)',
      memory: 'Mémoire (MiB)',
      memoryHint: 'podman --memory',
      health: 'Sonde de vivacité',
      healthCmd: 'Commande de la sonde',
      healthCmdHint: 'Exécutée dans le conteneur par le nœud à chaque tick de supervision — un argument par ligne ; sortie 0 = sain.',
      healthTimeout: 'Délai (s)',
      healthRetries: 'Tentatives',
      healthRetriesHint: 'Échecs consécutifs avant que le nœud redémarre le conteneur.',
      ips: 'Adresses statiques',
      ipsHint: 'Une par instance, dans l\'ordre des ordinaux — une mise à l\'échelle au-delà de la liste est refusée.',
      instance: 'instance',
      volumesHint: 'Les volumes sont ceux du Pod ; le chemin de montage est celui de chaque conteneur (onglet Conteneurs).',
      spread: 'Répartition',
      spreadHint_preferred: 'Instances sur des nœuds différents si possible.',
      spreadHint_required: 'Instances sur des nœuds différents, sinon la mise à l\'échelle refuse.',
      spreadHint_none: 'Le décideur seul.',
      ha: 'Haute disponibilité (opt-in)',
      haHint: 'Chaque pièce persistante sur un storage partagé ; si le nœud meurt, le decider HA recrée les instances sur un autre membre (failover automatique, comme les VM HA).',
      yes: 'oui',
      no: 'non'
    },
    detail: {
      container: 'Conteneur',
      actions: 'Actions',
      ready: 'Prêt',
      notReady: 'Pas prêt',
      restarts: 'Redémarrages',
      lastRestartAt: 'Dernier redémarrage :',
      backoffUntil: 'Réessai à',
      stateAbsent: 'absent',
      stateRunning: 'en cours',
      stateTerminated: 'terminé',
      stateWaiting: 'en attente',
      init: 'init',
      noInstances: 'Aucune instance (réplicas 0).',
      ha: 'HA',
      haHint: "Failover automatique : si le nœud meurt, le decider HA recrée l'instance sur un autre membre (chaque pièce persistante sur un storage partagé).",
      authority: 'Authority (nœud)',
      homeless: 'sans authority',
      homelessHint: "Une restauration depuis un checkpoint laisse l'authority de côté (#380) : aucun nœud ne la sert tant que vous ne redimensionnez pas le Pod (même au même nombre de répliques).",
      restartContainer: 'Redémarrer ce conteneur seul (le pod reste en place)',
      divergingHint: 'L\'état voulu de cette instance diverge du défaut du Pod (PD-P19).',
      revisionLag: 'révision {applied} appliquée sur {current}',
      updatedInstances: '{updated}/{desired} instances à cette révision'
    }
  }
}
